import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {NgForm} from '@angular/forms';
import {EventService} from '../../../services/event.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {BehaviorSubject, combineLatest, Observable, of, ReplaySubject, Subscription, switchMap, tap} from 'rxjs';
import {debounceTime, filter, map, take} from 'rxjs/operators';
import {Fonds} from '../../../models/fonds';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FondsService} from '../../../services/fonds.service';
import {ListControl} from '../../../models/uiArtefakt';
import {FondsMitAnteil} from '../../../models/fondsMitAnteil';
import {UiUpdateService} from '../../../services/ui-update.service';
import {ModalDialogFondsComponent, ModalDialogFondsInput} from '../modal-dialog/modal-dialog-fonds/modal-dialog-fonds.component';
import {FondsgruppeItem} from '../../../models/fondsgruppeItem';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ModalDialogButtonViewInput} from '../../button/modal-dialog-button/modal-dialog-button-view/modal-dialog-button-view.component';
import {ValidationService} from '../../../services/validation.service';
import {Notification, NotificationService, RuntimeContext} from '../../../../lib-core';
import {FondsPortfolioData} from '../../../models/fondsPortfolioData';
import {StageConfigService} from '../../../services/stage-config.service';
import {ShellConfigService} from '../../../services/shell-config.service';
import {MatSelect, MatSelectChange} from '@angular/material/select';
import {FondsVermittlerspezifischesPortfolio} from '../../../models/fondsVermittlerspezifischesPortfolio';
import {translations} from '../../../translations/de';
import {ModalDialogComponent} from '../../modal-dialog/modal-dialog.component';
import {
  ModalDialogPortfolioSpeichernComponent
} from '../portfolio-vermittlerspezifisch/modal-dialog-portfolio-speichern/modal-dialog-portfolio-speichern.component';
import {ModalDialogVorlageChangedComponent} from '../modal-dialog/modal-dialog-vorlage-changed/modal-dialog-vorlage-changed.component';
import {EventFondsService} from '../../../services/event-fonds.service';
import {GespeichertesPortfolioData} from '../fondstable-gespeichertes-portfolio/fonds-table-gespeichertes-portfolio.component';
import {TrackingService} from '../../../services/tracking.service';
import {TrackingAktion, TrackingCategory} from '../../../models/enumTracking';

export interface IndividualFonds {
  fondsId: number;
  name: string;
  isin: string;
  risikoklasse: number;
  factsheet: string;
  esgreport: string;
  anteil: number;
  markAsNichtVerfuegbar: boolean;
}

@Component({
    selector: 'lv-fonds-table-individuelles-portfolio',
    templateUrl: './fonds-table-individuelles-portfolio.component.html',
    styleUrls: ['./fonds-table-individuelles-portfolio.component.scss'],
    standalone: false
})
export class FondsTableIndividuellesPortfolioComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(NgForm, {static: true})
  private _ngForm;
  @ViewChild(MatSort)
  private _sort: MatSort;
  @ViewChild('dropdownIndividuellesPortfolio') private dropdownIndividuellesPortfolio!: MatSelect;

  public isVermittlerspezifischesPortfolioMoeglich: boolean;
  public kumulierteAnteile: number = 0;
  public showKumulierteAnteileNichtKorrekt: boolean;
  public risikoklasseGesamt: number = 0;
  public uiAusrichtung: UIAusrichtung;
  public dataSource: MatTableDataSource<IndividualFonds> = new MatTableDataSource([]);
  public selectedIndividualFonds$: Observable<IndividualFonds[]>;
  public fondsPortfolioData$: Observable<FondsPortfolioData>;
  public displayedColumns: string[] = ['anteil', 'name', 'risikoklasse', 'factsheet', 'esgreport', 'delete'];
  public _hiddenModel: string;
  public showUntruncatedError: boolean = false;
  public touchedAnteile: string[] = [];
  public autocomplete: string;
  public gespeicherteVermittlerspezifischePortfolios: FondsVermittlerspezifischesPortfolio[]; //Umbenennung in Portfolios
  public selectedVermittlerspezifischesPortfolio = {name: '0'} as FondsVermittlerspezifischesPortfolio;
  public gespeicherteVermittlerspezifischePortfolios$ = Subscription.EMPTY;
  public isSBShell: boolean = false;
  public showDevButtonsVermittlerspezifischesPortfolio: boolean;

  private _kumulierteAnteileLastValue;
  private _debounceSubscription = Subscription.EMPTY;
  private _selectedVermittlerspezifischesPortfolioInvestitionsbetragSubscription = Subscription.EMPTY;
  private _selectedVermittlerspezifischesPortfolioZuzahlungSubscription = Subscription.EMPTY;
  private _debounceAnteilSubject = new ReplaySubject<number>(1);
  private _alleAnteileDirty: boolean;
  private _uiArtefakt: ListControl;
  private _fondsliste$: BehaviorSubject<ListControl> = new BehaviorSubject<ListControl>(null);

  constructor(private _cd: ChangeDetectorRef, private _eventService: EventService, private _validationService: ValidationService,
              private _uiUpdateService: UiUpdateService, private matDialog: MatDialog,
              private _tracker: TrackingService, private _notificationService: NotificationService,
              @Inject(MAT_DIALOG_DATA) public data: ModalDialogButtonViewInput,
              private _shellConfigService: ShellConfigService, private _stageConfigService: StageConfigService,
              private _fondsService: FondsService, private _renderer: Renderer2, private _element: ElementRef,
              private _eventFondsService: EventFondsService) {
  }

  get hiddenModel(): string {
    if (!this._hiddenModel) {
      return void 0;
    }
    if (!!this.showKumulierteAnteileNichtKorrekt) {
      return void 0;
    }
    return 'true';
  }

  get uiArtefakt(): ListControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ListControl) {
    this._uiArtefakt = uiArtefakt;
    this._fondsliste$.next(uiArtefakt);
  }

  set hiddenModel(s: string) {
    this._hiddenModel = s;
  }

  ngOnDestroy(): void {
    this._debounceSubscription.unsubscribe();
    this.gespeicherteVermittlerspezifischePortfolios$.unsubscribe();
    this._selectedVermittlerspezifischesPortfolioInvestitionsbetragSubscription.unsubscribe();
    this._selectedVermittlerspezifischesPortfolioZuzahlungSubscription.unsubscribe();
  }

  applySort() {
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      const value = data[sortHeaderId];
      if (typeof value === 'string') {
        return value?.toLowerCase().replace('ö', 'o').replace('ü', 'u').replace('ä', 'a');
      }
      return data[sortHeaderId];
    };
    this.dataSource.sort = this._sort;

  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }

    this._ngForm.form.valueChanges.subscribe(changeMap => {
      if (!!this._sort && !this.dataSource.sort) {
        this.dataSource.sort = this._sort;
      }

      this._alleAnteileDirty = true;
      const allFormKeys = Object.keys(this._ngForm.form.controls);
      if (this._isFormInInitialZustand(allFormKeys)) {
        this.touchedAnteile = [];
      }
      allFormKeys.forEach(key => {
        if (key !== 'lvHidden' && !this.touchedAnteile.includes(key) && !this._ngForm.form.controls[key].valid) {
          this._alleAnteileDirty = false;
        }
      });

      allFormKeys.forEach(key => {
        if (this._ngForm.form.controls[key].touched && !this.touchedAnteile.includes(key)) {
          this.touchedAnteile.push(key);
        }
      });

      let kumulierteAnteileNeu = 0;
      Object.keys(changeMap).forEach(key => {
        if (key !== 'dropdownIndividuellesPortfolio' &&
            key !== 'individuellesPortfolioInitial' &&
            key !== 'lvHidden') {
          const anteil = +changeMap[key];
          if (!!anteil) {
            kumulierteAnteileNeu += anteil;
          }
        }
      });
      kumulierteAnteileNeu = Math.round(kumulierteAnteileNeu);
      this.risikoklasseGesamt = 0;
      if (kumulierteAnteileNeu === 100) {
        this.risikoklasseGesamt = Math.round(this._fondsService.getRisikoklasseDurchschnitt(
            this.uiArtefakt.UIArtefakt, this.dataSource.data));
      }
      this._debounceAnteilSubject.next(kumulierteAnteileNeu);
    });

    this._selectedVermittlerspezifischesPortfolioInvestitionsbetragSubscription =
        combineLatest<[GespeichertesPortfolioData, FondsVermittlerspezifischesPortfolio[]]>([
          this._eventFondsService.selectedVermittlerspezifischesPortfolioInvestitionsbetrag$,
          this._fondsService.getGespeicherteVermittlerspezifischePortfolios()]).pipe(
            filter(([_, __]) => this.isVermittlerspezifischesPortfolioMoeglich),
            filter(([gespeichertesPortfolioData, __]) =>
                this._fondsService.getAnlageKontext(this.uiArtefakt.FeldnameExtern) ===
                this._fondsService.getAnlageKontext(gespeichertesPortfolioData.feldnameExtern)),
            tap(([gespeichertesPortfolioData, __]) => {
              if (!gespeichertesPortfolioData.wertEingabe) {
                this.selectedVermittlerspezifischesPortfolio = {name: '0'} as FondsVermittlerspezifischesPortfolio;
                if (!this._eventFondsService.getInitialCheckVermittlerspezifischesPortfolioExecuted(
                    gespeichertesPortfolioData.feldnameExtern)) {
                  this._eventFondsService.setInitialCheckVermittlerspezifischesPortfolioExecuted(gespeichertesPortfolioData.feldnameExtern);
                }
              }
            }),
            filter(([gespeichertesPortfolioData, __]) => !!gespeichertesPortfolioData.wertEingabe),
            tap(([gespeichertesPortfolioData, __]) =>
                this._handleVermittlerSpezifischesPortfolioLogik(gespeichertesPortfolioData))
        ).subscribe();

    this._selectedVermittlerspezifischesPortfolioZuzahlungSubscription =
        combineLatest<[GespeichertesPortfolioData, FondsVermittlerspezifischesPortfolio[]]>([
          this._eventFondsService.selectedVermittlerspezifischesPortfolioZuzahlung$,
          this._fondsService.getGespeicherteVermittlerspezifischePortfolios()]).pipe(
            filter(([_, __]) => this.isVermittlerspezifischesPortfolioMoeglich),
            filter(([gespeichertesPortfolioData, __]) =>
                this._fondsService.getAnlageKontext(this.uiArtefakt.FeldnameExtern) ===
                this._fondsService.getAnlageKontext(gespeichertesPortfolioData.feldnameExtern)),
            tap(([gespeichertesPortfolioData, __]) => {
              if (!gespeichertesPortfolioData.wertEingabe) {
                this.selectedVermittlerspezifischesPortfolio = {name: '0'} as FondsVermittlerspezifischesPortfolio;
                if (!this._eventFondsService.getInitialCheckVermittlerspezifischesPortfolioExecuted(
                    gespeichertesPortfolioData.feldnameExtern)) {
                  this._eventFondsService.setInitialCheckVermittlerspezifischesPortfolioExecuted(gespeichertesPortfolioData.feldnameExtern);
                }
              }
            }),
            filter(([gespeichertesPortfolioData, __]) => !!gespeichertesPortfolioData.wertEingabe),
            tap(([gespeichertesPortfolioData, __]) =>
                this._handleVermittlerSpezifischesPortfolioLogik(gespeichertesPortfolioData))
        ).subscribe();
  }

  public ngOnInit(): void {
    this.showDevButtonsVermittlerspezifischesPortfolio = this._stageConfigService.showDevButtonsVermittlerspezifischesPortfolio();
    this.isVermittlerspezifischesPortfolioMoeglich = this._stageConfigService.isVermittlerspezifischesPortfolioMoeglich();
    this.isSBShell = this._shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL;
    this.gespeicherteVermittlerspezifischePortfolios$ = this._fondsService.getGespeicherteVermittlerspezifischePortfolios()
        .pipe(
            filter(resp => !!resp),
            tap(resp => {
              this.gespeicherteVermittlerspezifischePortfolios = resp;
              this.gespeicherteVermittlerspezifischePortfolios.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            }),
        ).subscribe();
    this.fondsPortfolioData$ = this._fondsService.fondsPortfolioData$;
    this._debounceSubscription = this._debounceAnteilSubject.pipe(
        tap(kumulierteAnteile => {
          if (this.kumulierteAnteile === 100 || kumulierteAnteile === 100 || !this._alleAnteileDirty) {
            this.showKumulierteAnteileNichtKorrekt = false;
          }
          this.kumulierteAnteile = kumulierteAnteile;
        }),
        debounceTime(1300),
        filter(kumulierteAnteile => kumulierteAnteile !== 100 && this._alleAnteileDirty),
        tap(_ => this.showKumulierteAnteileNichtKorrekt = true)).subscribe();

    this.selectedIndividualFonds$ = combineLatest<[Fonds[], Fonds[], ListControl]>([
      this._fondsService.getAllFonds(), this._fondsService.getAllFondsMitGeschlossenen(), this._fondsliste$]).pipe(
          map(([fonds, fondsMitGeschlossenen, fondsTableListe]) => {
          const fondsDataMap: Map<number, number> = new Map<number, number>();
          const model = fondsTableListe.UIArtefakt;
          model.forEach(fondsSel => {
            const wpid = fondsSel.UIArtefakt.filter(fondsItem => fondsItem.FeldnameExtern === '/wpid')[0];
            const anteil = fondsSel.UIArtefakt.filter(fondsItem => fondsItem.FeldnameExtern === '/fondsaufteilungssatz')[0];
            if (!!wpid.WertEingabe) {
              fondsDataMap.set(wpid.WertEingabe, anteil.WertEingabe);
            }
          });
          const individualFonds: IndividualFonds[] = [];
          const individuellGewaehlteFonds: FondsMitAnteil[] = [];
          const geloeschteFonds: FondsMitAnteil[] = [];

          Array.from(fondsDataMap.keys()).forEach(wpid => {
            const foundFondsMitAnteil = fonds.filter(einzelfonds => einzelfonds.fondsId === wpid)[0] as FondsMitAnteil;
            if (!!foundFondsMitAnteil) {
              individuellGewaehlteFonds.push(foundFondsMitAnteil);
            } else {
              // tritt auf wenn ein fonds nicht mehr verfügbar ist (z.b. nicht mehr verkaufsoffen).
              const foundFondVersuch2 = fondsMitGeschlossenen.filter(einzelfonds => einzelfonds.fondsId === wpid)[0] as FondsMitAnteil;
              if (!!foundFondVersuch2) {
                if (!!this.isSBShell) {
                  foundFondVersuch2.markAsNichtVerfuegbar = true;
                  individuellGewaehlteFonds.push(foundFondVersuch2);
                } else {
                  // wenn nicht SB-Shell wird der Fonds gelöscht und der Nutzer bekommt eine Notification
                  this.deleteFonds(wpid);
                  geloeschteFonds.push(foundFondVersuch2);
                }
              } else {
                // wird der fonds auch nicht bei den geschlossenen gefunden gibt es ihn einfach nicht mehr
                // bzw. es ist eine völlige fehleingabe und er wird aus dem modell entfernt.
                // Sollte nicht vorkommen, aber wer weiß.....
                this.deleteFonds(wpid);
              }
            }
          });
          if (!!geloeschteFonds.length) {
            let listeAllerGeloeschteFonds = '<ul>';
            geloeschteFonds.forEach(geloeschterFonds => {
              listeAllerGeloeschteFonds += '<li>' + geloeschterFonds.name + ' (ISIN: ' + geloeschterFonds.isin + ')</li>';
            });
            listeAllerGeloeschteFonds += '</ul>';
            const kontextBezeichnung = this._fondsService.getAnlageKontextAsString(
                this._fondsService.getAnlageKontext(this._uiArtefakt.FeldnameExtern));
            const notification = new Notification(
                'Alert', 'Danger', 'Korrektur des Portfolios erforderlich',
                'Folgende Fonds sind nicht verfügbar und wurden für dieses Angebot aus Ihrem individuellen Portfolio ' +
                '<b>' + kontextBezeichnung + '</b> entfernt: ' + listeAllerGeloeschteFonds, true, null);
            this._notificationService.addNotification(notification);
          }

          individuellGewaehlteFonds.filter(einzelfonds => !!einzelfonds).forEach(einzelfonds => {
            let prozentWert;
            if (!!fondsDataMap.get(einzelfonds.fondsId)) {
              prozentWert = Math.round(fondsDataMap.get(einzelfonds.fondsId) * 100);
            }
            individualFonds.push({
              fondsId: einzelfonds.fondsId, name: einzelfonds.name, isin: einzelfonds.isin,
              risikoklasse: einzelfonds.risikoklasse,
              factsheet: einzelfonds.factsheet, esgreport: einzelfonds.esgreport,
              anteil: prozentWert,
              markAsNichtVerfuegbar: einzelfonds.markAsNichtVerfuegbar
            });
          });
          let kumulierteProzente = 0;
          individualFonds.forEach(individualFond => kumulierteProzente += individualFond.anteil);
          this._debounceAnteilSubject.next(kumulierteProzente);
          this.dataSource = new MatTableDataSource(individualFonds);
          this.applySort();
          this._hiddenModel = this._getHiddenModel(individualFonds);
          return individualFonds;
        })
    );
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
  }

  onChangeAnteil($event: number, id: number, isValid: boolean) {
    const anteilStatus = this._ngForm?.form?.controls[id]?.status;
    if (anteilStatus === 'VALID' || !$event) {
      this._fondsService.updateFondsInUiControl({fondsId: id, prozentualerAnteil: $event}, this.uiArtefakt);
      this._addiereAnteile();
    }
  }

  onDeleteAllPortolios() {
    this._fondsService.deleteAllVermittlerspezifischePortfolio().pipe(take(1)).subscribe();
  }

  onCreateTestDataPortfolios() {
    this._fondsService.createVermittlerspezifischesPortfolioTestdata().pipe(take(1)).subscribe();
  }

  deleteFonds(fondsId: number): void {
    this.touchedAnteile = this.touchedAnteile.filter(item => item !== fondsId + '');
    const leftArtefacts = this.uiArtefakt.UIArtefakt.filter(artefakt => {
      const wpid = artefakt.UIArtefakt.filter(fondsItem => fondsItem.FeldnameExtern === '/wpid')[0];
      return wpid.WertEingabe !== fondsId;
    });
    this.uiArtefakt.UIArtefakt = leftArtefacts;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  getLink(schriftstueckArt: string, fondsId: number): string {
    return this._fondsService.getLink(schriftstueckArt, fondsId);
  }

  fondsIndividuellClicked() {
    const input = new ModalDialogFondsInput();
    input.fonds$ = this._fondsService.getAllFonds();
    if (this._uiArtefakt.FeldnameExtern === '/listePortfolio') {
      input.unmanagedFonds$ = this._fondsService.unmanagedFonds$;
    }
    if (this._uiArtefakt.FeldnameExtern === '/listePortfolioZuzahlung') {
      input.unmanagedFonds$ = this._fondsService.unmanagedFondsZuzahlung$;
    }
    input.uiControl$ = this._eventService.uiControls$;
    const selectedFonds: number[] = [];
    this.uiArtefakt.UIArtefakt.forEach(fonds => {
      const wpid = fonds.UIArtefakt.filter(fondsItem => fondsItem.FeldnameExtern === '/wpid')[0];
      if (!!wpid?.WertEingabe) {
        const index = selectedFonds.indexOf(wpid.WertEingabe);
        if (index < 0) {
          selectedFonds.push(wpid.WertEingabe);
        }
      }
    });
    input.selectedFonds = selectedFonds;
    this.matDialog.open<ModalDialogFondsComponent,
        ModalDialogFondsInput, number[]>(ModalDialogFondsComponent, {
      panelClass: 'lv-fonds-modaldialog',
      data: input,
      disableClose: true,
      width: '60%',
      height: '86%',
      autoFocus: false
    }).afterClosed().pipe(
        filter(newSelectedFonds => !!newSelectedFonds),
        map(newSelectedFonds => {
          const fondsgruppeItems: FondsgruppeItem[] = [];
          newSelectedFonds.forEach(fondsId => {
            const item = {} as FondsgruppeItem;
            item.fondsId = fondsId;
            fondsgruppeItems.push(item);
          });
          return fondsgruppeItems;
        }),
        switchMap(fondsgruppeItems =>
            this._fondsService.setSelectedFondsInUiControl(fondsgruppeItems, null, this._uiArtefakt)),
        tap(_ => this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt))
    ).subscribe();
  }

  gleichgewichten(): void {
    const sortedFonds = this.dataSource.sortData(this.dataSource.data, this._sort);
    sortedFonds.forEach((fonds, index) => {
      this._uiArtefakt.UIArtefakt.forEach(fondsArtefakt => {
        const wpidArtefakt = fondsArtefakt.UIArtefakt.filter(
            fondsItem => fondsItem.FeldnameExtern === '/wpid')[0];
        const anteilArtefakt = fondsArtefakt.UIArtefakt.filter(
            fondsItem => fondsItem.FeldnameExtern === '/fondsaufteilungssatz')[0];
        if (wpidArtefakt.WertEingabe + '' === fonds.fondsId + '') {
          anteilArtefakt.WertEingabe = this._fondsService.getAnteilGleichgewichtet(sortedFonds.length, index);
        }
      });
    });
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  fondsHinzufuegen() {
    this.fondsIndividuellClicked();
  }

  onFondsSpeichern() {
    this._tracker.trackEvent(TrackingCategory.SPEICHERN, TrackingAktion.T_BUTTON, 'PortfolioSpeichern_Aufruf');
    this._addiereAnteile();
    const anzahlAnteileUndefined = Object.keys(this._ngForm.form.controls).filter(key => !!(+key))
        .filter(key => this._ngForm.form.controls[key].value === undefined).length;
    const anzahlAnteileInvalid = Object.keys(this._ngForm.form.controls).filter(key => !!(+key))
        .filter(key => this._ngForm.form.controls[key].status === 'INVALID').length;
    if (this._kumulierteAnteileLastValue !== 100 || !!anzahlAnteileUndefined || !!anzahlAnteileInvalid) {
      if (this._kumulierteAnteileLastValue === 100 && !!anzahlAnteileUndefined) {
        this.matDialog.open<ModalDialogComponent>(ModalDialogComponent, {
          data: {
            titel: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_FEHLENDE_ANGABEN.TITEL,
            content: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_FEHLENDE_ANGABEN.MELDUNG,
            bezWeiterButton: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_FEHLENDE_ANGABEN.BUTTON_WEITER
          },
          panelClass: 'lv-modal-dialog',
          disableClose: true,
          autoFocus: true
        }).afterClosed().pipe(
            tap(_ => {
              this._validationService.markControlsDirtyAndTouched(this._ngForm.form);
            }),
        ).subscribe();

      } else {
        if (this._kumulierteAnteileLastValue !== 100) {
          this.matDialog.open<ModalDialogComponent>(ModalDialogComponent, {
            data: {
              titel: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_ANTEIL_FEHLERHAFT.TITEL,
              content: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_ANTEIL_FEHLERHAFT.MELDUNG,
              bezWeiterButton: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_SPEICHERN_ANTEIL_FEHLERHAFT.BUTTON_WEITER
            },
            panelClass: 'lv-modal-dialog',
            disableClose: true,
            autoFocus: true
          }).afterClosed().pipe(
              tap(_ => {
                this._validationService.markControlsDirtyAndTouched(this._ngForm.form);
              }),
          ).subscribe();
        }
      }
    } else {
      const isEqual =
          this._fondsService.isPortfolio1AndPortfolio2Equal(
              this._fondsService.getFondsMitAnteilen(this.uiArtefakt), this.selectedVermittlerspezifischesPortfolio?.items);
      if (!!this.selectedVermittlerspezifischesPortfolio.id && !isEqual) {
        this.matDialog.open<ModalDialogVorlageChangedComponent>(ModalDialogVorlageChangedComponent, {
          data: {
            name: this.selectedVermittlerspezifischesPortfolio.name
          },
          panelClass: 'lv-modal-dialog',
          width: '50%',
          height: '60%',
          disableClose: true,
          autoFocus: false
        }).afterClosed().pipe(
            take(1),
            filter(data => data.dosave),
            tap(data => {
              if (!data.portfolioName) {
                this._updateVermmittlerspezifischesPortfolio();
              }
            }),
            filter(data => !!data.portfolioName),
            switchMap(data => this._saveVermittlerspezifischesPortfolio(data.portfolioName))
        ).subscribe();
      } else {
        if( !!this.selectedVermittlerspezifischesPortfolio?.id){
          this._updateVermmittlerspezifischesPortfolio();
        } else {
          this.matDialog.open<ModalDialogPortfolioSpeichernComponent>(ModalDialogPortfolioSpeichernComponent, {
            data: {gespeicherteFondsNamen: this.gespeicherteVermittlerspezifischePortfolios},
            panelClass: 'lv-modal-dialog',
            disableClose: true,
            autoFocus: false
          }).afterClosed().pipe(
              take(1),
              switchMap(data => this._saveVermittlerspezifischesPortfolio(data))
          ).subscribe();
        }
      }
    }
  }

  public hasError(): boolean {
    return this._ngForm.form.status !== 'VALID' && this._ngForm.form?.controls['lvHidden']?.touched;
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }

  isTouched(fondsId: number): boolean {
    return this.touchedAnteile.includes(fondsId + '');
  }

  getErrors(fondsId: any): any {
    return this._ngForm?.form?.controls[fondsId]?.errors;
  }

  onChangeIndividuellesPortfolio(event: MatSelectChange) {
    if (!event.value) {
      this.fondsIndividuellClicked();
    } else {
      this.changeSelectedPortfolio(event.value);
    }
  }

  onSelectionIndividuellesPortfolioClicked(event: any, value: any) {
    const isEqual =
        this._fondsService.isPortfolio1AndPortfolio2Equal(
            this._fondsService.getFondsMitAnteilen(this.uiArtefakt), this.selectedVermittlerspezifischesPortfolio?.items);
    if (!isEqual && this._fondsService.getFondsMitAnteilen(this.uiArtefakt).length > 0) {
      event.stopPropagation();
      const dialogRef = this.matDialog.open(ModalDialogComponent, {
        width: '450px',
        data: {
          titel: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_BEARBEITET_WECHSELN.TITEL,
          content: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_BEARBEITET_WECHSELN.MELDUNG,
          bezAbbrechenButton: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_BEARBEITET_WECHSELN.BUTTON_ABBRECHEN,
          bezWeiterButton: translations.MODAL_DIALOG.FONDS.VERMITTLERSPEZIFISCHES_PORTFOLIO_BEARBEITET_WECHSELN.BUTTON_WEITER
        },
        panelClass: 'lv-modal-dialog',
        disableClose: true,
        autoFocus: false
      }).afterClosed().pipe(
          tap(result => {
            if (!!result) {
              this.changeSelectedPortfolio(value);
            }
            this.dropdownIndividuellesPortfolio.close();
          })
      ).subscribe();
    } else {
      this.changeSelectedPortfolio(value);
    }
  }

  changeSelectedPortfolio(portfolio: any) {
    this._fondsService.updateVermittlerspezifischesPortfolioInUiControl(portfolio.id,
        this._fondsService.getAnlageKontext(this._uiArtefakt.FeldnameExtern));
    this.selectedVermittlerspezifischesPortfolio = portfolio as FondsVermittlerspezifischesPortfolio;
    //Alte Fonds Liste wird entfernt
    this._uiArtefakt.UIArtefakt = [this._uiArtefakt.UIArtefakt[0]];
    this._fondsService.setSelectedFondsInUiControl(this.selectedVermittlerspezifischesPortfolio.items, null, this._uiArtefakt).pipe(
        tap(_ => {
          this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt);
          if (!this.selectedVermittlerspezifischesPortfolio?.id){
            this.selectedVermittlerspezifischesPortfolio = {name: '0'} as FondsVermittlerspezifischesPortfolio;
          }
        }),
        take(1)
    ).subscribe();
  }

  private _saveVermittlerspezifischesPortfolio(portfolioName: string) {
    return of(portfolioName).pipe(
        take(1),
        filter(name => !!name),
        map(name => {
          const payload = {} as FondsVermittlerspezifischesPortfolio;
          payload.name = name;
          payload.items = this._fondsService.getFondsMitAnteilen(this._uiArtefakt);
          return payload;
        }),
        switchMap(fondsVermittlerspezifischesPortfolio =>
            this._fondsService.saveVermittlerspezifischesPortfolio(fondsVermittlerspezifischesPortfolio)),
        tap(fondsVermittlerspezifischesPortfolio => {
          if (fondsVermittlerspezifischesPortfolio !== null) {
            this.gespeicherteVermittlerspezifischePortfolios.push(fondsVermittlerspezifischesPortfolio);
            this.gespeicherteVermittlerspezifischePortfolios.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            const dropdown = this._ngForm.form.controls['dropdownIndividuellesPortfolio'];
            const matSelectChange = {source: dropdown, value: fondsVermittlerspezifischesPortfolio};
            this.onChangeIndividuellesPortfolio(matSelectChange);
          }
        })
    );
  }

  private _updateVermmittlerspezifischesPortfolio() {
    const payload = {} as FondsVermittlerspezifischesPortfolio;
    payload.id = this.selectedVermittlerspezifischesPortfolio.id;
    payload.name = this.selectedVermittlerspezifischesPortfolio.name;
    payload.items = this._fondsService.getFondsMitAnteilen(this._uiArtefakt);
    this._fondsService.updateVermittlerspezifischesPortfolio(payload,
        this.selectedVermittlerspezifischesPortfolio.id).pipe(take(1)).subscribe();
    this.gespeicherteVermittlerspezifischePortfolios = this.gespeicherteVermittlerspezifischePortfolios
        .map(item => item.name !== payload.name ? item : payload);
    this._fondsService.updateVermittlerspezifischesPortfolioInUiControl(payload.id,
        this._fondsService.getAnlageKontext(this.uiArtefakt.FeldnameExtern));
    this.selectedVermittlerspezifischesPortfolio = payload as FondsVermittlerspezifischesPortfolio;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  private _handleVermittlerSpezifischesPortfolioLogik(gespeichertesPortfolioData) {
    const gespeichertesPortfolio: FondsVermittlerspezifischesPortfolio =
        this.gespeicherteVermittlerspezifischePortfolios?.filter(portfolio =>
            portfolio.id === gespeichertesPortfolioData.wertEingabe)[0];
    let gespeichertesPortfolioItems;
    if (!!gespeichertesPortfolio) {
      gespeichertesPortfolioItems = gespeichertesPortfolio.items;
    }
    if (!!this._eventFondsService.getInitialCheckVermittlerspezifischesPortfolioExecuted(
        gespeichertesPortfolioData.feldnameExtern)) {
      // hier ist die Logik ab request 2
      const isEqual =
          this._fondsService.isPortfolio1AndPortfolio2Equal(
              this._fondsService.getFondsMitAnteilen(this.uiArtefakt), gespeichertesPortfolioItems);
      if (!isEqual) {
        // bei eigener Änderung des nutzers kommt ein reset der ausgewählten vermittlerspezifischen PortfolioId auf null
        this._fondsService.updateVermittlerspezifischesPortfolioInUiControl(null,
            this._fondsService.getAnlageKontext(gespeichertesPortfolioData.feldnameExtern));
      } else {
        // wenns keine änderung gibt wird einfach das neu gewählte portfolio gesetzt und geladen
        if (!!gespeichertesPortfolio) {
          this.selectedVermittlerspezifischesPortfolio = gespeichertesPortfolio;
          this._cd.detectChanges();
        }
      }
    } else {
      // hier ist die Logik für den initial request
      const isEqual =
          this._fondsService.isPortfolio1AndPortfolio2Equal(
              this._fondsService.getFondsMitAnteilen(this.uiArtefakt), gespeichertesPortfolioItems);
      if (!isEqual) {
        // hier hats eine Änderung des Portfolios auf der DB gegeben, entweder über einen anderen Antrag oder
        // über die Portfolio Verwaltung, dann kommt der Toast
        this._fondsService.manageAbweichungVermittlerspezifischesPortfolio(
            this._fondsService.getAnlageKontext(gespeichertesPortfolioData.feldnameExtern));
      } else {
        // falls die Fonds im UiVorgang und das Portfolio auf der DB gleich sind kann einfach das Portfolio gesetzt werden
        if (!!gespeichertesPortfolio) {
          this.selectedVermittlerspezifischesPortfolio = gespeichertesPortfolio;
        }
      }
    }
  }

  private _getHiddenModel(selectedIndividualFonds: IndividualFonds[]): string {
    return !!selectedIndividualFonds.length ? 'true' : void 0;
  }

  private _isFormInInitialZustand(allFormKeys: string[]) {
    return allFormKeys?.length === 1 && allFormKeys[0] === 'individuellesPortfolioInitial';
  }

  private _addiereAnteile() {
    let kumulierteAnteileNeu = 0;
    Object.keys(this._ngForm.form.controls).forEach(key => {
      if (key !== 'dropdownIndividuellesPortfolio' &&
          key !== 'individuellesPortfolioInitial' &&
          key !== 'lvHidden') {
        const anteil = +this._ngForm.form.controls[key].value;
        if (!!anteil) {
          kumulierteAnteileNeu += anteil;
        }
      }
    });
    if (kumulierteAnteileNeu === 100 && this._kumulierteAnteileLastValue !== 100) {
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
    }
    this._kumulierteAnteileLastValue = kumulierteAnteileNeu;
  }
}
